module.exports = __webpack_public_path__ + "images/41d76a1f58a34c22c90b847df199950034dd31a6d87edb8f2cf5eea3358d92a5.svg";